import React from 'react';
import { Container, Col } from 'reactstrap';
import HeadLogo from '../../../shared/images/veterans-logo-2x.png';
import ApplicationFooter from '../../../shared/components/ApplicationFooter'
import FooterDescription from '../../../shared/components/FooterDescription';

function NotFoundPage() {
    return (
        <div className="form-container">
            <Container>
                <Col lg="12" className="text-center">
                    <img src={HeadLogo}
                        alt="vetrains-logo"
                        className="vetrains-logo" />
                </Col>
                <Col>
                    <Col lg="12" className="text-center not-found-logo">
                        <div className="icon-notFoundLogo">
                            <div className="path2" />
                        </div>
                    </Col>
                    <Col className="text-center pt-3 not-found-title">
                        404
                    </Col>
                    <Col className="text-center not-found-sub-title">
                        page not found
                    </Col>
                    <Col lg="12" className="form-sub-header pb-3">
                        Oops! Looks like the link is broken. The page you are looking for doesn't exist.
                    </Col>

                </Col>
                <Col lg={{ size: 8, offset: 2 }}
                    xs={{ size: 12, offset: 0 }}>
                    <FooterDescription color="white" />
                </Col>
                <ApplicationFooter isLogin={true} />
            </Container>


        </div>
    )
}

export default NotFoundPage